import type { UserRoleName } from 'src/generated'

// ----------------------------------------------------------------------
// Who may see the Costs pages.
//
// They are Beast's own cost base: what Beast pays the vendors that run the
// platform, its books and its price lists. Not a fleet's, so Beast staff
// only, as every costs field on the backend is (`@auth(roles: [superAdmin])`
// and `ensureBeastAdmin`, held by `costsBeastOnly.test.ts`). The route, the
// nav entry and any link in read this one list. See docs/COSTS.md.
// ----------------------------------------------------------------------

/**
 * The roles the Costs pages admit. Spread into `roles` on a menu entry and
 * `requiredRole` on a route, so both read the same list.
 */
export const COSTS_ROLES: readonly UserRoleName[] = ['superAdmin']

/** Whether this viewer may see the Costs pages. */
export const costsVisibleTo = (
  role: UserRoleName | null | undefined,
): boolean => role != null && COSTS_ROLES.includes(role)
